"use strict";
export const DEFAULT_INACTIVE_LIST_URLS = ["https://tokens.pancakeswap.finance/pancakeswap-extended.json"];
